(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["design-system"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = matchMedia('(pointer: fine)');
  const running = new WeakMap();
  let audio, soundOn = false, pressed, pointerFrame;
  try { soundOn = localStorage.getItem('launchforge-sound') === 'on'; } catch {}
  const soundButton = document.querySelector('[data-sound-toggle]');
  function syncSound() {
    if (!soundButton) return;
    soundButton.textContent = soundOn ? (soundButton.dataset.soundOn || 'Sound on') : (soundButton.dataset.soundOff || 'Sound off');
    soundButton.setAttribute('aria-pressed', String(soundOn));
    soundButton.setAttribute('aria-label', soundOn ? (soundButton.dataset.soundDisable || 'Disable click sounds') : (soundButton.dataset.soundEnable || 'Enable click sounds'));
  }
  function tone() {
    if (!soundOn) return;
    try {
      const Audio = window.AudioContext || window.webkitAudioContext;
      if (!Audio) { soundOn = false; syncSound(); return; }
      audio ||= new Audio();
      if (audio.state === 'suspended') void audio.resume().catch(() => {});
      const oscillator = audio.createOscillator(), gain = audio.createGain();
      const now = audio.currentTime;
      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(1400, now);
      oscillator.frequency.exponentialRampToValueAtTime(580, now + .065);
      gain.gain.setValueAtTime(.0001, now);
      gain.gain.exponentialRampToValueAtTime(.035, now + .008);
      gain.gain.exponentialRampToValueAtTime(.0001, now + .08);
      oscillator.connect(gain); gain.connect(audio.destination);
      oscillator.start(now); oscillator.stop(now + .09);
      oscillator.onended = () => { oscillator.disconnect(); gain.disconnect(); };
    } catch { soundOn = false; syncSound(); }
  }
  function reveal(element, compact = false) {
    if (!element || reduced.matches || typeof element.animate !== 'function') return;
    running.get(element)?.cancel();
    const animation = element.animate([
      { opacity: .4, transform: `translateY(${compact ? 5 : 12}px) scale(${compact ? 1 : .985})`, boxShadow: '0 0 0 1px #8be9ffb0, 0 0 45px #8be9ff25' },
      { opacity: 1, transform: 'translateY(0) scale(1)', boxShadow: getComputedStyle(element).boxShadow }
    ], { duration: compact ? 180 : 280, easing: 'cubic-bezier(.2,.8,.2,1)' });
    running.set(element, animation);
  }
  function pulse(target, event) {
    if (reduced.matches) return;
    const rect = target.getBoundingClientRect();
    const ring = document.createElement('span');
    ring.className = 'action-pulse'; ring.setAttribute('aria-hidden', 'true');
    ring.style.left = `${event.detail ? event.clientX : rect.left + rect.width / 2}px`;
    ring.style.top = `${event.detail ? event.clientY : rect.top + rect.height / 2}px`;
    (target.closest('dialog') || document.body).append(ring);
    ring.addEventListener('animationend', () => ring.remove(), { once: true });
    setTimeout(() => ring.remove(), 550);
  }
  syncSound();
  soundButton?.addEventListener('click', () => {
    soundOn = !soundOn; syncSound();
    try { localStorage.setItem('launchforge-sound', soundOn ? 'on' : 'off'); } catch {}
    if (soundOn) tone();
  });
  document.addEventListener('click', event => {
    const target = event.target.closest('button,a,summary');
    if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return;
    pulse(target, event);
    if (!target.hasAttribute('data-sound-toggle')) tone();
  }, true);
  document.addEventListener('pointerdown', event => {
    const target = event.target.closest('button,a,summary');
    if (!target || target.disabled) return;
    pressed?.classList.remove('is-pressed'); pressed = target;
    pressed.classList.add('is-pressed');
  });
  const release = () => { pressed?.classList.remove('is-pressed'); pressed = null; };
  document.addEventListener('pointerup', release);
  document.addEventListener('pointercancel', release);
  window.addEventListener('blur', release);
  document.addEventListener('pointermove', event => {
    if (!finePointer.matches || reduced.matches) return;
    const card = event.target.closest('.product-card');
    if (!card) return;
    cancelAnimationFrame(pointerFrame);
    pointerFrame = requestAnimationFrame(() => {
      const rect = card.getBoundingClientRect();
      card.style.setProperty('--pointer-x', `${event.clientX - rect.left}px`);
      card.style.setProperty('--pointer-y', `${event.clientY - rect.top}px`);
    });
  }, { passive: true });
  reduced.addEventListener('change', () => {
    if (!reduced.matches) return;
    document.querySelectorAll('.action-pulse').forEach(ring => ring.remove());
    document.querySelectorAll('dialog,.preview-paper').forEach(element => running.get(element)?.cancel());
  });
  window.BizzLinePluggFX = Object.freeze({ reveal });
})();

(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let activeTransition;
  addEventListener('pageswap', event => {
    const transition = event.viewTransition;
    if (!transition) return;
    activeTransition = transition;
    const destination = event.activation?.entry?.url;
    if (!destination || !new URL(destination).pathname.startsWith('/products/') || reduced.matches) transition.skipTransition();
  });
  addEventListener('pagereveal', event => {
    activeTransition = event.viewTransition;
    if (reduced.matches) activeTransition?.skipTransition();
  });
  for (const type of ['pointerdown', 'keydown']) addEventListener(type, () => activeTransition?.skipTransition(), {capture:true});
  document.addEventListener('toggle', event => {
    if (event.target.matches('.lf-preview-panel[open]')) window.BizzLinePluggFX?.reveal(event.target.querySelector('.lf-preview-body'), true);
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
